var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThinSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4666 10.9344L14.4666 13.9344C14.7333 14.201 14.7333 14.601 14.4666 14.8677C14.3333 15.001 14.1333 15.0677 13.9999 15.0677C13.8666 15.0677 13.6666 15.001 13.5333 14.8677L10.5333 11.8677C9.53325 12.601 8.33325 13.0677 6.99992 13.0677C3.86659 13.0677 1.33325 10.5344 1.33325 7.40104C1.33325 4.26771 3.86659 1.73438 6.99992 1.73438C10.1333 1.73438 12.6666 4.26771 12.6666 7.40104C12.6666 8.73438 12.1999 10.001 11.4666 10.9344ZM6.99992 3.06771C4.59992 3.06771 2.66659 5.00104 2.66659 7.40104C2.66659 9.80104 4.59992 11.7344 6.99992 11.7344C8.19992 11.7344 9.26659 11.2677 10.0666 10.4677C10.8666 9.66771 11.3333 8.60104 11.3333 7.40104C11.3333 5.00104 9.39992 3.06771 6.99992 3.06771Z",
    fill: "#828282"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10982_6573",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4666 10.9344L14.4666 13.9344C14.7333 14.201 14.7333 14.601 14.4666 14.8677C14.3333 15.001 14.1333 15.0677 13.9999 15.0677C13.8666 15.0677 13.6666 15.001 13.5333 14.8677L10.5333 11.8677C9.53325 12.601 8.33325 13.0677 6.99992 13.0677C3.86659 13.0677 1.33325 10.5344 1.33325 7.40104C1.33325 4.26771 3.86659 1.73438 6.99992 1.73438C10.1333 1.73438 12.6666 4.26771 12.6666 7.40104C12.6666 8.73438 12.1999 10.001 11.4666 10.9344ZM6.99992 3.06771C4.59992 3.06771 2.66659 5.00104 2.66659 7.40104C2.66659 9.80104 4.59992 11.7344 6.99992 11.7344C8.19992 11.7344 9.26659 11.2677 10.0666 10.4677C10.8666 9.66771 11.3333 8.60104 11.3333 7.40104C11.3333 5.00104 9.39992 3.06771 6.99992 3.06771Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10982_6573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.402344H16V16.4023H0V0.402344Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinSearchIcon);
export default __webpack_public_path__ + "static/media/ThinSearchIcon.84a158701cf452d1e1aa337af3716f53.svg";
export { ForwardRef as ReactComponent };